import { ArticlesBox } from "@foodpilot/foods";

import { ArticlesSectionProps } from "./types";
import { mapArticlesToProps } from "./utils/articleUtils";

export const ArticlesSection = (props: ArticlesSectionProps) => {
    const { articles } = props;
    const articleProps = mapArticlesToProps(articles);

    return <ArticlesBox articles={articleProps} />;
};
